<template>
	<div :class="['select', { opened: opened }]" v-click-away="close">
		<div
			:class="['select-item', value ? 'filled' : '']"
			@click="open($event)"
		>
			{{ selectedValue }}
			<img src="images/icons/chevron-down-green.svg" />
		</div>
		<label @click="open($event)">{{ label }}</label>
		<div class="select-list" v-show="opened">
			<div
				v-for="(item, i) in filteredList"
				:key="i"
				@click="selectItem(item)"
			>
				{{ item.text }}
			</div>
		</div>
	</div>
</template>

<script>
import { getDictionaryItem } from '@/mixins/get-dictionary-item';
export default {
	data() {
		return {
			opened: false,
			selectedValue: '',
			filteredList: [],
		};
	},
	props: {
		id: {
			type: String,
			required: false,
			default: '',
		},
		label: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			required: false,
			default: '',
		},
		list: {
			type: Array,
			required: true,
		},
	},
	mixins: [getDictionaryItem],
	methods: {
		open() {
			this.opened = !this.opened;
			this.filteredList = this.list;
		},
		close() {
			this.opened = false;
			this.filteredList = this.list;
		},
		selectItem(item) {
			this.$emit('input', item);
			this.opened = false;
			this.selectedValue = item.text;
		},
		filterList(e) {
			let query = e.target.value;

			this.filteredList = this.list.filter((item) => {
				if (
					item.text.toLowerCase().indexOf(query.toLowerCase()) !== -1
				) {
					return item;
				}
			});
		},
	},
	mounted() {
		this.filteredList = this.list;
		//this.selectedText = this.getDictionaryItem(this.list, 'text', 'text', this.value)
	},
};
</script>
